// extracted by mini-css-extract-plugin
export default {"customControlAttachmentButtonStyle":"ControlAttachment_customControlAttachmentButtonStyle__RbWeq"};